import req from "../http";

const factory = {
  // 取得 廠別(分頁)
  getFactoryPaging(params) {
    return req("get", "/BasicInformation/FactoryType/Paging", params);
  },

  // 取得 廠別
  getFactory(params) {
    return req("get", "/BasicInformation/FactoryType", params);
  },

  // 新增 廠別
  postFactory(params) {
    return req("post", "/BasicInformation/FactoryType", params);
  },

  // 編輯 廠別
  putFactory(params) {
    return req("put", "/BasicInformation/FactoryType", params);
  },

  // 刪除 廠別
  deleteFactory(guid) {
    return req("delete", "/BasicInformation/FactoryType", guid);
  },
};

export default factory;